import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import _0_45auth_45validate_45token_45global from "/vercel/path0/apps/site/app/middleware/0.authValidateToken.global.ts";
import _1_45auth_45provider_45global from "/vercel/path0/apps/site/app/middleware/1.authProvider.global.ts";
import _2_45utm_45global from "/vercel/path0/apps/site/app/middleware/2.utm.global.js";
import _3_45navigation_45global from "/vercel/path0/apps/site/app/middleware/3.navigation.global.ts";
import maintenance_45global from "/vercel/path0/apps/site/app/middleware/maintenance.global.ts";
export const globalMiddleware = [
  validate,
  _0_45auth_45validate_45token_45global,
  _1_45auth_45provider_45global,
  _2_45utm_45global,
  _3_45navigation_45global,
  maintenance_45global
]
export const namedMiddleware = {
  account: () => import("/vercel/path0/apps/site/app/middleware/account.ts"),
  house: () => import("/vercel/path0/apps/site/app/middleware/house.ts"),
  login: () => import("/vercel/path0/apps/site/app/middleware/login.ts"),
  "property-sales": () => import("/vercel/path0/apps/site/app/middleware/property-sales.js"),
  "redirect-wishlist": () => import("/vercel/path0/apps/site/app/middleware/redirect-wishlist.ts"),
  "search-destination-validation": () => import("/vercel/path0/apps/site/app/middleware/search-destination-validation.ts"),
  "stay-proposal-edit": () => import("/vercel/path0/apps/site/app/middleware/stay-proposal-edit.js"),
  "unapproved-contract-information": () => import("/vercel/path0/apps/site/app/middleware/unapproved-contract-information.js")
}